import { filterValueToQuery, camelObjectToSnakeObject } from '@/api';
import {
  CreatePurchaseOrderInput,
  UpdatePurchaseOrderInput,
  PurchaseOrderFillInput,
  UpdatePurchaseOrderItemInput,
  UpdatePurchaseOrderMiscItemInput,
} from '@/types/purchase-order';

export default function purchaseOrder(axios: any) {
  async function getPurchaseOrders(filter: any) {
    try {
      const response = await axios.get(`/api/purchase_orders?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] getPurchaseOrders Error', e);
    }
    return null;
  }

  async function getPurchaseOrderItems(filter: any) {
    try {
      const response = await axios.get(`/api/purchase_order_items?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] getPurchaseOrderItems Error', e);
    }
    return null;
  }

  async function getPurchaseOrderLogs(id: number, filter: any) {
    try {
      const response = await axios.get(`/api/purchase_orders/${id}/logs?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        console.log(response.data);
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] getPurchaseOrderLogs Error', e);
    }
    return null;
  }

  async function getPurchaseOrderMiscItems(filter: any) {
    try {
      const response = await axios.get(`/api/purchase_order_misc_items?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] getPurchaseOrderMiscItems Error', e);
    }
    return null;
  }

  async function getPurchaseOrderItemsUnion(filter: any) {
    try {
      const response = await axios.get(`/api/purchase_order_items/union?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response;
      }
    } catch (e) {
      console.error('[api/purchase-order] getPurchaseOrderItemsUnion Error', e);
    }
    return null;
  }

  async function getPurchaseOrder(id: number) {
    const response = await axios.get(`/api/purchase_orders/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] getPurchaseOrder Error', e);
    }
    return null;
  }

  async function createPurchaseOrder(payload: CreatePurchaseOrderInput) {
    const response = await axios.post('/api/purchase_orders', camelObjectToSnakeObject(payload, ['miscItems', 'subType']));
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/purchase-order] createPurchaseOrder Error', e);
    }
    return null;
  }

  async function updatePurchaseOrder(id: number, payload: UpdatePurchaseOrderInput) {
    const response = await axios.put(`/api/purchase_orders/${id}`, camelObjectToSnakeObject(payload, ['miscItems', 'subType']));
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/purchase-order] updatePurchaseOrder Error', e);
    }
    return null;
  }

  async function getPurchaseOrderStats(filter: any) {
    const response = await axios.get(`/api/purchase_orders/stats?${filterValueToQuery(filter)}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] getPurchaseOrderStats Error', e);
    }
    return null;
  }

  async function updatePurchaseOrderFill(id: number, payload: PurchaseOrderFillInput) {
    const response = await axios.post(`/api/purchase_orders/${id}/fill`, camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] updatePurchaseOrderFill Error', e);
    }
    return null;
  }

  async function searchPurchaseOrderItems(payload: any, type = 'purchase_order_items') {
    const response = await axios.post(`/api/${type}/search`, payload);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] searchPurchaseOrderItems Error', e);
    }
    return null;
  }

  async function updatePurchaseOrderItem(id: number, payload: UpdatePurchaseOrderItemInput) {
    const response = await axios.put(`/api/purchase_order_items/${id}`, camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] updatePurchaseOrderItem Error', e);
    }
    return null;
  }

  async function updatePurchaseOrderMiscItem(id: number, payload: UpdatePurchaseOrderMiscItemInput) {
    const response = await axios.put(`/api/purchase_order_misc_items/${id}`, camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] updatePurchaseOrderMiscItem Error', e);
    }
    return null;
  }

  async function approvePurchaseOrder(id: number, payload: any) {
    const response = await axios.post(`/api/purchase_orders/${id}/approve`, payload);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] approvePurchaseOrder Error', e);
    }
    return null;
  }

  async function revisePurchaseOrder(id: number, payload: any) {
    const response = await axios.post(`/api/purchase_orders/${id}/revise`, camelObjectToSnakeObject(payload, ['miscItems']));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] revisePurchaseOrder Error', e);
    }
    return null;
  }

  async function checkExistingPurchaseOrderCode(code: string) {
    const response = await axios.get(`/api/purchase_orders/check/${code}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] checkExistingPurchaseOrderCode Error', e);
    }
    return {
      exist: false,
      code: '',
    };
  }

  return {
    getPurchaseOrders,
    getPurchaseOrder,
    getPurchaseOrderStats,
    createPurchaseOrder,
    updatePurchaseOrder,
    updatePurchaseOrderFill,

    getPurchaseOrderItems,
    getPurchaseOrderMiscItems,
    getPurchaseOrderItemsUnion,
    searchPurchaseOrderItems,
    updatePurchaseOrderItem,
    updatePurchaseOrderMiscItem,

    getPurchaseOrderLogs,

    approvePurchaseOrder,
    revisePurchaseOrder,
    checkExistingPurchaseOrderCode,
  };
}
